export default "__VITE_ASSET__UDikI0bu__"